// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FinishScheduleCostCodeQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FinishScheduleCostCodeQuery = { __typename?: 'Query', costCodes: Array<{ __typename?: 'CostCode', id: string, name: string, interiorFinishScheduleLabel?: string | null | undefined, interiorFinishScheduleDescription?: string | null | undefined, exteriorFinishScheduleLabel?: string | null | undefined, exteriorFinishScheduleDescription?: string | null | undefined, items: Array<{ __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number }> }>, interiorFinishScheduleConfigs: Array<{ __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined }>, exteriorFinishScheduleConfigs: Array<{ __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined }> }> };

export type SaveFinishScheduleCostCodeMutationVariables = Types.Exact<{
  input: Types.SaveCostCodesInput;
}>;


export type SaveFinishScheduleCostCodeMutation = { __typename?: 'Mutation', saveCostCodes: { __typename?: 'SaveCostCodesResult', costCodes: Array<{ __typename?: 'CostCode', id: string, name: string, interiorFinishScheduleLabel?: string | null | undefined, interiorFinishScheduleDescription?: string | null | undefined, exteriorFinishScheduleLabel?: string | null | undefined, exteriorFinishScheduleDescription?: string | null | undefined, items: Array<{ __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number }> }>, interiorFinishScheduleConfigs: Array<{ __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined }>, exteriorFinishScheduleConfigs: Array<{ __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined }> }> } };

export type FinishScheduleCostCodeDetailFragment = { __typename?: 'CostCode', id: string, name: string, interiorFinishScheduleLabel?: string | null | undefined, interiorFinishScheduleDescription?: string | null | undefined, exteriorFinishScheduleLabel?: string | null | undefined, exteriorFinishScheduleDescription?: string | null | undefined, items: Array<{ __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number }> }>, interiorFinishScheduleConfigs: Array<{ __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined }>, exteriorFinishScheduleConfigs: Array<{ __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined }> };

export type FinishScheduleConfigFieldsFragment = { __typename?: 'FinishScheduleConfig', id: string, sortOrder: number, shown: boolean, useInVisualMode: boolean, sourceAttribute?: string | null | undefined, label?: string | null | undefined, type: { __typename?: 'FinishScheduleColumnTypeDetail', code: Types.FinishScheduleColumnType, name: string }, coreColumn?: { __typename?: 'FinishScheduleCoreColumnDetail', code: Types.FinishScheduleCoreColumn, name: string } | null | undefined };

export const FinishScheduleConfigFieldsFragmentDoc = gql`
    fragment FinishScheduleConfigFields on FinishScheduleConfig {
  id
  sortOrder
  shown
  useInVisualMode
  type {
    code
    name
  }
  coreColumn {
    code
    name
  }
  sourceAttribute
  label
}
    `;
export const FinishScheduleCostCodeDetailFragmentDoc = gql`
    fragment FinishScheduleCostCodeDetail on CostCode {
  id
  name
  interiorFinishScheduleLabel
  interiorFinishScheduleDescription
  exteriorFinishScheduleLabel
  exteriorFinishScheduleDescription
  items {
    id
    name
    materialAttributeDimensions {
      id
      name
      sortOrder
    }
  }
  interiorFinishScheduleConfigs {
    ...FinishScheduleConfigFields
  }
  exteriorFinishScheduleConfigs {
    ...FinishScheduleConfigFields
  }
}
    ${FinishScheduleConfigFieldsFragmentDoc}`;
export const FinishScheduleCostCodeDocument = gql`
    query FinishScheduleCostCode($id: ID!) {
  costCodes(filter: {id: [$id], version: [2]}) {
    ...FinishScheduleCostCodeDetail
  }
}
    ${FinishScheduleCostCodeDetailFragmentDoc}`;

/**
 * __useFinishScheduleCostCodeQuery__
 *
 * To run a query within a React component, call `useFinishScheduleCostCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishScheduleCostCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishScheduleCostCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishScheduleCostCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables> & ({ variables: FinishScheduleCostCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>(FinishScheduleCostCodeDocument, options);
      }
export function useFinishScheduleCostCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>(FinishScheduleCostCodeDocument, options);
        }
// @ts-ignore
export function useFinishScheduleCostCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>;
export function useFinishScheduleCostCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FinishScheduleCostCodeQuery | undefined, FinishScheduleCostCodeQueryVariables>;
export function useFinishScheduleCostCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>(FinishScheduleCostCodeDocument, options);
        }
export type FinishScheduleCostCodeQueryHookResult = ReturnType<typeof useFinishScheduleCostCodeQuery>;
export type FinishScheduleCostCodeLazyQueryHookResult = ReturnType<typeof useFinishScheduleCostCodeLazyQuery>;
export type FinishScheduleCostCodeSuspenseQueryHookResult = ReturnType<typeof useFinishScheduleCostCodeSuspenseQuery>;
export type FinishScheduleCostCodeQueryResult = ApolloReactCommon.QueryResult<FinishScheduleCostCodeQuery, FinishScheduleCostCodeQueryVariables>;
export const SaveFinishScheduleCostCodeDocument = gql`
    mutation SaveFinishScheduleCostCode($input: SaveCostCodesInput!) {
  saveCostCodes(input: $input) {
    costCodes {
      ...FinishScheduleCostCodeDetail
    }
  }
}
    ${FinishScheduleCostCodeDetailFragmentDoc}`;

/**
 * __useSaveFinishScheduleCostCodeMutation__
 *
 * To run a mutation, you first call `useSaveFinishScheduleCostCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFinishScheduleCostCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFinishScheduleCostCodeMutation, { data, loading, error }] = useSaveFinishScheduleCostCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFinishScheduleCostCodeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFinishScheduleCostCodeMutation, SaveFinishScheduleCostCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFinishScheduleCostCodeMutation, SaveFinishScheduleCostCodeMutationVariables>(SaveFinishScheduleCostCodeDocument, options);
      }
export type SaveFinishScheduleCostCodeMutationHookResult = ReturnType<typeof useSaveFinishScheduleCostCodeMutation>;
export type SaveFinishScheduleCostCodeMutationResult = ApolloReactCommon.MutationResult<SaveFinishScheduleCostCodeMutation>;